import React, { useEffect } from "react";
import { Separator } from "../../ui/separator";

const TaxInfo = () => {

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <main className="flex-grow bg-white py-8 md:py-12">
      <div className="container mx-auto px-2 md:px-4">
        <div className="max-w-4xl mx-auto">
          {/* Page Header */}
          <div className="mb-8 md:mb-12">
            <h1 className="text-3xl font-bold mb-6 text-center text-[#523880]">
              Tax Deduction Terms for Creators
            </h1>
            <p className="text-sm text-gray-500 text-center mb-8">
              Effective Date: Jun 02, 2025
            </p>
          </div>

          {/* Content */}
          <div className="prose prose-lg max-w-none">
            <p className="text-base leading-relaxed text-gray-800 mb-4">
              This document outlines the Tax Deduction at Source (TDS) and Tax
              Collection at Source (TCS) applicable to all Creators engaging
              in gigs via the Oye Creators platform. It is governed by the
              Indian Income-tax Act, 1961 and relevant government
              notifications.
            </p>

            <Separator className="my-8 bg-gray-200" />

            <section className="mb-8">
              <h2 className="text-xl font-semibold mt-8 mb-4 text-[#EE3788]">
                1. Definitions
              </h2>
              <ul className="list-disc ml-6 space-y-2">
                <li className="text-base leading-relaxed text-gray-800">
                  <strong>Creator</strong>: An individual or entity registered
                  on Oye Creators who performs gigs and earns fees.
                </li>
                <li className="text-base leading-relaxed text-gray-800">
                  <strong>TDS</strong>: Tax Deducted at Source under the
                  Income-tax Act, 1961.
                </li>
                <li className="text-base leading-relaxed text-gray-800">
                  <strong>TCS</strong>: Tax Collection at Source as per
                  Section 206C of the Income-tax Act, 1961.
                </li>
                <li className="text-base leading-relaxed text-gray-800">
                  <strong>PAN</strong>: Permanent Account Number issued by the
                  Income Tax Department of India.
                </li>
              </ul>
            </section>

            <Separator className="my-8 bg-gray-200" />

            <section className="mb-8">
              <h2 className="text-xl font-semibold mt-8 mb-4 text-[#EE3788]">
                2. TDS & TCS Applicability
              </h2>
              <ul className="list-disc ml-6 space-y-2">
                <li className="text-base leading-relaxed text-gray-800">
                  <strong>TCS</strong>: 1% of the total gig fee will be
                  collected by Oye Creators at source and remitted to the
                  government.
                </li>
                <li className="text-base leading-relaxed text-gray-800">
                  <strong>TDS</strong>: 10% of the total gig fee will be
                  deducted at source and remitted to the government.
                </li>
                <li className="text-base leading-relaxed text-gray-800">
                  These deductions apply to <strong>all</strong> Creators,
                  unless a valid self-declaration is provided (see Section 4).
                </li>
              </ul>
            </section>

            <Separator className="my-8 bg-gray-200" />

            <section className="mb-8">
              <h2 className="text-xl font-semibold mt-8 mb-4 text-[#EE3788]">
                3. PAN Verification & Inactive PAN
              </h2>
              <ul className="list-disc ml-6 space-y-2">
                <li className="text-base leading-relaxed text-gray-800">
                  Creators must provide a valid PAN during onboarding.
                </li>
                <li className="text-base leading-relaxed text-gray-800">
                  If a Creator's PAN is marked inactive, invalid, or not
                  provided, a higher TDS rate of <strong>20%</strong> will be
                  applied, in accordance with Section 206AA of the Income-tax
                  Act.
                </li>
              </ul>
            </section>

            <Separator className="my-8 bg-gray-200" />

            <section className="mb-8">
              <h2 className="text-xl font-semibold mt-8 mb-4 text-[#EE3788]">
                4. Self-Declaration & Exemption
              </h2>
              <ul className="list-disc ml-6 space-y-2">
                <li className="text-base leading-relaxed text-gray-800">
                  A Creator may submit a self-declaration confirming they will
                  manage their own tax liabilities.
                </li>
                <li className="text-base leading-relaxed text-gray-800">
                  Upon acceptance of this declaration and digital signature of
                  the agreement, Oye Creators will <strong>not</strong> deduct
                  TDS.
                </li>
                <li className="text-base leading-relaxed text-gray-800">
                  The declaration form must comply with Form 15G/15H
                  guidelines (as applicable) under the Income-tax Act.
                </li>
              </ul>
            </section>

            <Separator className="my-8 bg-gray-200" />

            <section className="mb-8">
              <h2 className="text-xl font-semibold mt-8 mb-4 text-[#EE3788]">
                5. Digital Agreement Execution
              </h2>
              <ul className="list-disc ml-6 space-y-2">
                <li className="text-base leading-relaxed text-gray-800">
                  All tax-related declarations and the platform agreement must
                  be signed electronically via the Platform's digital
                  signature mechanism.
                </li>
                <li className="text-base leading-relaxed text-gray-800">
                  Only upon successful digital execution will any TDS
                  exemptions be honored.
                </li>
              </ul>
            </section>

            <Separator className="my-8 bg-gray-200" />

            <section className="mb-8">
              <h2 className="text-xl font-semibold mt-8 mb-4 text-[#EE3788]">
                6. Indemnification & Governing Law
              </h2>
              <ul className="list-disc ml-6 space-y-2">
                <li className="text-base leading-relaxed text-gray-800">
                  The Creator shall indemnify and hold harmless Oye Creators
                  from any tax claims, penalties, or interest arising from
                  incorrect PAN details or false declarations.
                </li>
                <li className="text-base leading-relaxed text-gray-800">
                  These terms are governed by the laws of India and disputes
                  will be subject to the courts of Pune, Maharashtra.
                </li>
              </ul>
            </section>
          </div>
        </div>
      </div>
    </main>
  )
}

export default TaxInfo
